module.exports = __webpack_public_path__ + "img/thex_image.bda669d8.jpg";